import { FingerprintProvider } from '@fingerprint/react'
import { StyledEngineProvider } from '@mui/material/styles'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import './App.css'
import { PrivateRoutes } from './components/redirects'
import { AppConfigProvider } from './context/config'
import AdminPage from './pages/AdminPage/AdminPage'

import HomePage from './pages/HomePage/HomePage'
import LogInPage from './pages/LogInPage/LogInPage'
import SignUpPage from './pages/SignUpPage/SignUpPage'
import { FPJS_API_KEY } from './utils/env'

function App() {
  return (
    <>
      <FingerprintProvider apiKey={FPJS_API_KEY} endpoints={[`https://fp.tryfingerprint.com`]}>
        <AppConfigProvider>
          <StyledEngineProvider injectFirst>
            <BrowserRouter>
              <Routes>
                <Route element={<PrivateRoutes />}>
                  <Route path='/' element={<HomePage />} />
                  <Route path='/admin' element={<AdminPage />} />
                </Route>
                <Route path='login' element={<LogInPage />} />
                <Route path='signup' element={<SignUpPage />} />
                <Route path='*' element={<Navigate to='/' replace />} />
              </Routes>
            </BrowserRouter>
          </StyledEngineProvider>
        </AppConfigProvider>
      </FingerprintProvider>
    </>
  )
}

export default App
